<template>
  <div class="config-schema-form">
    <div v-if="!parsedSchema || parsedSchema.length === 0" class="no-config-placeholder" style="text-align:center;padding:40px;color:#909399;">
      <i class="el-icon-info" style="font-size:48px;"></i>
      <p style="margin-top:12px;">此项目暂无配置需求</p>
    </div>

    <div v-else v-for="(group, gIdx) in groupedFields" :key="gIdx" class="config-group" style="margin-bottom:24px;">
      <h4 style="border-left:3px solid #409EFF;padding-left:10px;margin-bottom:16px;color:#303133;">{{ group.groupName }}</h4>
      <el-form label-width="140px" size="small">
        <el-form-item
          v-for="field in group.fields"
          :key="field.key"
          :label="field.label"
          :required="field.required"
        >
          <el-input
            v-if="field.type === 'input' || !field.type"
            v-model="formValues[field.key]"
            :placeholder="field.placeholder || '请输入' + field.label"
            clearable
          />
          <el-input
            v-else-if="field.type === 'password'"
            v-model="formValues[field.key]"
            type="password"
            :placeholder="field.placeholder || '请输入' + field.label"
            show-password
            clearable
          />
          <el-input
            v-else-if="field.type === 'textarea'"
            v-model="formValues[field.key]"
            type="textarea"
            :rows="3"
            :placeholder="field.placeholder || '请输入' + field.label"
          />
          <el-input-number
            v-else-if="field.type === 'number'"
            v-model="formValues[field.key]"
            :placeholder="field.placeholder || '请输入' + field.label"
            style="width:100%;"
          />
          <el-select
            v-else-if="field.type === 'select'"
            v-model="formValues[field.key]"
            :placeholder="field.placeholder || '请选择' + field.label"
            clearable
            filterable
            style="width:100%;"
          >
            <el-option
              v-for="opt in (field.options || [])"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
          <p v-if="field.description" style="color:#909399;font-size:12px;line-height:1.4;margin:4px 0 0;">{{ field.description }}</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfigSchemaForm",
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    schema: {
      type: [String, Array],
      default: null
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formValues: {}
    }
  },
  computed: {
    parsedSchema() {
      if (!this.schema) return null;
      if (Array.isArray(this.schema)) return this.schema;
      try {
        const parsed = JSON.parse(this.schema);
        return Array.isArray(parsed) ? parsed : null;
      } catch (e) {
        return null;
      }
    },
    groupedFields() {
      if (!this.parsedSchema) return [];
      const groups = {};
      for (const item of this.parsedSchema) {
        // 支持两种格式：
        // 1. 嵌套格式：{group:"xxx", fields:[{key,label,type,...}]}
        // 2. 扁平格式：{group:"xxx", key, label, type, ...}
        if (item.fields && Array.isArray(item.fields)) {
          const groupName = item.group || '基础配置';
          if (!groups[groupName]) {
            groups[groupName] = { groupName, fields: [] };
          }
          for (const field of item.fields) {
            groups[groupName].fields.push(field);
          }
        } else {
          const groupName = item.group || '基础配置';
          if (!groups[groupName]) {
            groups[groupName] = { groupName, fields: [] };
          }
          groups[groupName].fields.push(item);
        }
      }
      // Sort fields by order within each group
      for (const key of Object.keys(groups)) {
        groups[key].fields.sort((a, b) => (a.order || 999) - (b.order || 999));
      }
      return Object.values(groups);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.initFormValues(val);
      }
    },
    formValues: {
      deep: true,
      handler(val) {
        const json = JSON.stringify(val);
        if (json !== this._lastEmitted) {
          this._lastEmitted = json;
          this.$emit('input', { ...val });
        }
      }
    }
  },
  created() {
    this._lastEmitted = '';
  },
  methods: {
    initFormValues(val) {
      const values = val && typeof val === 'object' ? { ...val } : {};
      if (this.parsedSchema) {
        for (const field of this.parsedSchema) {
          if (values[field.key] === undefined && field.default !== undefined) {
            values[field.key] = field.default;
          }
        }
      }
      const json = JSON.stringify(values);
      if (json !== JSON.stringify(this.formValues)) {
        this.formValues = values;
      }
    }
  }
}
</script>
